import { http } from "./config";

export const genericUpdate = async (key, value, uuid) => {
  const { data } = await http.patch(`/activations/generic-update/${uuid}`, { key, value });
  return data;
};